module.exports = __webpack_public_path__ + "img/lebedeva.4566ef8c.jpg";